@if ($colorRamp(); as colorRamp) {
    <div class="color-ramp-editor">
        <!-- Ramp image preview -->
        <div class="gradient-preview">
            <img [src]="$rampImageDataUrl()" alt="Color Ramp" style="width: 100%; height: 24px; display: block; border-radius: 4px" />
        </div>

        <!-- Color stops indicators -->
        <div class="color-stops-container">
            @for (stop of $colorStops(); track $index) {
                <div class="color-stop" (click)="$stopIndex.set($index)" [style.left.%]="stop.position * 100" [attr.data-index]="$index">
                    <div
                        class="stop-handle"
                        [ngClass]="{selected: $stopIndex() === $index}"
                        [style.background-color]="
                            'rgb(' +
                            $linearToSrgb()(stop.color.r) * 255 +
                            ',' +
                            $linearToSrgb()(stop.color.g) * 255 +
                            ',' +
                            $linearToSrgb()(stop.color.b) * 255 +
                            ')'
                        "
                    ></div>
                </div>
            }
        </div>

        <!-- Edit selected stop -->
        <div class="edit-stop">
            <!-- Selected stop details -->
            <div class="edit-stop-buttons-container">
                <div class="edit-stop-buttons">
                    <cm-button (click)="incrementIndex()" [disabled]="$stopIndex() <= 0">
                        <ng-container cm-left-icon><i class="fa fa-angle-left"></i></ng-container>
                    </cm-button>
                    <cm-button (click)="decrementIndex()" [disabled]="$stopIndex() >= $colorStops().length - 1">
                        <ng-container cm-left-icon><i class="fa fa-angle-right"></i></ng-container>
                    </cm-button>
                    {{ $stopIndex() + 1 }} / {{ $colorStops().length }}
                </div>
                <div class="edit-stop-buttons">
                    <cm-button (click)="addColorStop()">
                        <ng-container cm-left-icon><i class="fa fa-plus"></i></ng-container>
                    </cm-button>
                    <cm-button (click)="removeColorStop($stopIndex())" [disabled]="$colorStops().length <= 2">
                        <ng-container cm-left-icon><i class="fa fa-minus"></i></ng-container>
                    </cm-button>
                </div>
            </div>
            <cm-scalar-input-socket
                label="Position"
                type="number"
                [range]="{min: $minPosition(), max: $maxPosition()}"
                [value]="$stop().position"
                (valueChange)="updateColorStop($stopIndex(), {position: $event})"
            ></cm-scalar-input-socket>
            <cm-color-input-socket
                label="Color"
                type="color"
                [value]="$stop().color"
                (valueChange)="updateColorStop($stopIndex(), {color: $event})"
            ></cm-color-input-socket>
            <cm-scalar-input-socket
                label="Alpha"
                type="number"
                [range]="{min: 0, max: 1}"
                [value]="$stop().alpha"
                (valueChange)="updateColorStop($stopIndex(), {alpha: $event})"
            ></cm-scalar-input-socket>
        </div>
    </div>
}
